import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { OutletRating } from "@/app/services/generated/outletratingService";
import { outletRatingService } from "@/app/services/generated/outletratingService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasOutletRatingsCache {
  outletRatings: OutletRatingsCache;
}

// Singleton cache store
const outletRatingsCacheStore = new EntityCacheStore<OutletRating>(
  EnumCacheEntityType.outletRating,
  async () => outletRatingService.getAllOutletRatings()
);

// Ephemeral reader
export default class OutletRatingsCache extends EntityWithGuidKeyCache<OutletRating> {
  constructor() {
    super(outletRatingsCacheStore, (x) => x.id);
  }
}
